module.exports = __webpack_public_path__ + "static/media/coach-bg.bb03aa1b.png";